const PRODUCTION_HOSTNAME = "partners.creso.in";
const SIGNUP_CUSTOM_EVENT = "SignUpPartnerWeb";

function trackMetaCustomEvent(event: string, params?: Record<string, unknown>) {
  if (window.location.hostname !== PRODUCTION_HOSTNAME) return;

  const { fbq } = window;
  if (typeof fbq !== "function") return;

  fbq("trackCustom", event, params);
}

export function trackMetaSignup() {
  trackMetaCustomEvent(SIGNUP_CUSTOM_EVENT, {
    value: 1.0,
    currency: "INR",
  });
}
